'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import { ShowcaseIcon } from './scene-primitives';
import { collectionSteps, CollectionStepButton, pl } from './trend-research';
import { BlurSwap } from './playback-controls';
import { referenceBrands } from './workflow-facts';
export function CollectionFileList({ files: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'mt-auto px-3 pt-4 pb-2 max-md:hidden'}>
      <p
        className={
          'text-ink-3 flex h-6 items-center gap-1.5 text-[12px] leading-4'
        }
      >
        <ShowcaseIcon name={'folder'} className={'size-3.5'} />
        {translateShowcaseNode(showcaseCopy, 'LISI\xC8RE / FW27')}
        <span className={'num text-ink-4 ml-auto'}>
          {translateShowcaseNode(showcaseCopy, e.length)}
          {translateShowcaseNode(showcaseCopy, ' ')}
          {translateShowcaseNode(
            showcaseCopy,
            e.length === 1 ? 'file' : 'files'
          )}
        </span>
      </p>
      <ul className={'mt-1 flex min-h-[192px] flex-col'}>
        {translateShowcaseNode(
          showcaseCopy,
          e.map((e) => (
            <li
              key={e.key}
              className={
                'enter flex h-8 items-center gap-2 text-[13px] leading-5'
              }
            >
              <ShowcaseIcon
                name={e.file.icon}
                className={'text-ink-3 size-4 shrink-0'}
              />
              <span className={'text-ink min-w-0 flex-1 truncate'}>
                {translateShowcaseNode(showcaseCopy, e.file.name)}
              </span>
              <span className={'text-ink-4 shrink-0 text-[12px]'}>
                {translateShowcaseNode(showcaseCopy, e.file.kind)}
              </span>
            </li>
          ))
        )}
      </ul>
    </div>
  );
}
export function CollectionStepRail({
  items: e,
  active: t,
  progress: n,
  finished: r,
  onSelect: i,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let a = e.find((e) => e.index === t)?.workflow,
    o = collectionSteps.filter((e, n) => n < t || (n === t && r));
  return (
    <div className={'flex min-w-0 flex-col'}>
      <ol className={'flex flex-col gap-0 px-1 pt-1 max-md:hidden'}>
        {translateShowcaseNode(
          showcaseCopy,
          e.map(({ workflow: r, index: a }, o) => {
            let s = a === t ? 'active' : a < t ? 'done' : 'next';
            return (
              <li key={r.key} className={'relative'}>
                {translateShowcaseNode(
                  showcaseCopy,
                  o < e.length - 1 ? (
                    <span
                      aria-hidden={!0}
                      className={
                        'absolute top-[42px] bottom-[-6px] left-[25px] w-px bg-[var(--border)]'
                      }
                    >
                      <span
                        className={
                          'absolute inset-0 origin-top bg-[var(--foreground)] transition-transform duration-500 ease-[var(--ease)]'
                        }
                        style={{
                          transform: `scaleY(${+(s === 'done')})`,
                        }}
                      />
                    </span>
                  ) : null
                )}
                <button
                  type={'button'}
                  aria-current={s === 'active' ? 'step' : void 0}
                  onClick={() => i(a)}
                  className={`press flex w-full items-start gap-3 rounded-[12px] px-2.5 py-2.5 text-left transition-[background-color] duration-150 ${s === 'active' ? 'bg-[var(--state-wash)]' : 'hover:bg-[var(--hover-wash)]'}`}
                >
                  <CollectionStepButton state={s} icon={r.icon} progress={n} />
                  <span className={'min-w-0 flex-1 pt-[5px]'}>
                    <span
                      className={`block text-[14px] leading-5 ${s === 'next' ? 'text-ink-3' : 'text-ink'}`}
                    >
                      {translateShowcaseNode(showcaseCopy, r.name)}
                    </span>
                    <span className={'acc'} data-open={s === 'active'}>
                      <span className={'block overflow-hidden'}>
                        <span
                          className={
                            'text-ink-3 block pt-1 text-[13px] leading-[19px] text-pretty'
                          }
                        >
                          {translateShowcaseNode(showcaseCopy, r.does)}
                        </span>
                      </span>
                    </span>
                  </span>
                </button>
              </li>
            );
          })
        )}
      </ol>
      <CollectionFileList files={o} />
      <div className={'md:hidden'}>
        <ol className={'flex items-center px-1'}>
          {translateShowcaseNode(
            showcaseCopy,
            e.map(({ workflow: e, index: r }, a) => {
              let o = r === t ? 'active' : r < t ? 'done' : 'next';
              return (
                <React.Fragment key={e.key}>
                  {translateShowcaseNode(
                    showcaseCopy,
                    a > 0 ? (
                      <li
                        aria-hidden={!0}
                        className={
                          'relative mx-1 h-px min-w-3 flex-1 bg-[var(--border)]'
                        }
                      >
                        <span
                          className={
                            'absolute inset-0 origin-left bg-[var(--foreground)] transition-transform duration-500 ease-[var(--ease)]'
                          }
                          style={{
                            transform: `scaleX(${+(r <= t)})`,
                          }}
                        />
                      </li>
                    ) : null
                  )}
                  <li className={'shrink-0'}>
                    <button
                      type={'button'}
                      aria-current={o === 'active' ? 'step' : void 0}
                      aria-label={translateShowcaseNode(showcaseCopy, e.name)}
                      onClick={() => i(r)}
                      className={
                        'press flex h-11 min-w-11 items-center justify-center gap-2 rounded-[10px] px-1'
                      }
                    >
                      <CollectionStepButton
                        state={o}
                        icon={e.icon}
                        progress={n}
                      />
                      <span
                        className={`text-[13px] ${o === 'active' ? 'text-ink' : 'sr-only'}`}
                      >
                        {translateShowcaseNode(showcaseCopy, e.short)}
                      </span>
                    </button>
                  </li>
                </React.Fragment>
              );
            })
          )}
        </ol>
        {translateShowcaseNode(
          showcaseCopy,
          a ? (
            <div className={'px-2 pt-1 pb-2'}>
              <p className={'text-ink text-[14px] leading-5 font-medium'}>
                <BlurSwap value={a.name} />
              </p>
              <p
                className={
                  'text-ink-3 mt-0.5 min-h-[38px] text-[13px] leading-[19px]'
                }
              >
                <BlurSwap value={a.does} />
              </p>
            </div>
          ) : null
        )}
      </div>
    </div>
  );
}
export function CollectionBrandChip() {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <svg viewBox={'0 0 46 13'} aria-hidden={!0} className={'ref-logo'}>
      <rect width={'46'} height={'13'} rx={'1'} fill={'#F2EEE6'} />
      <text
        x={'23'}
        y={'8.7'}
        textAnchor={'middle'}
        fill={'#1C1A17'}
        fontFamily={"Georgia, 'Times New Roman', serif"}
        fontSize={'5.4'}
        letterSpacing={'1.2'}
      >
        {translateShowcaseNode(showcaseCopy, 'LISI\xC8RE')}
      </text>
    </svg>
  );
}
export function CollectionPrompt() {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <p className={'text-ink min-w-0 text-[14px] leading-5 max-sm:text-[13px]'}>
      <span className={'ref ref-violet'}>
        <ShowcaseIcon name={'layers'} className={'ref-icon'} />
        {translateShowcaseNode(showcaseCopy, pl.name)}
      </span>
      {translateShowcaseNode(showcaseCopy, ' ')}
      <span className={'ref ref-amber'}>
        <CollectionBrandChip />
        <span className={'sr-only'}>
          {translateShowcaseNode(showcaseCopy, referenceBrands.lisiere.name)}
        </span>
      </span>
      {translateShowcaseNode(showcaseCopy, ' ')}
      <span className={'text-ink-2'}>
        {translateShowcaseNode(showcaseCopy, 'FW27 capsule')}
      </span>
      <span className={'text-ink-3 max-lg:hidden'}>
        {translateShowcaseNode(showcaseCopy, ', tailoring and knitwear')}
      </span>
    </p>
  );
}
export function useCollectionHeight(e) {
  let t = React.useRef(null),
    [n, r] = React.useState(null);
  return (
    React.useLayoutEffect(() => {
      let n = t.current?.children[e];
      if (!(n instanceof HTMLElement)) return;
      let i = () => r(n.offsetHeight);
      i();
      let a = new ResizeObserver(i);
      return (a.observe(n), () => a.disconnect());
    }, [e]),
    [t, n]
  );
}
export const bl = 1800;
export const xl = collectionSteps.length - 1;
